module.exports = __webpack_public_path__ + "5c583cd221ca3e129a37632b59b3b787.png";